import { sha256 } from '@noble/hashes/sha2.js';

const digestCache = new WeakMap<File, string>();
const CHUNK_BYTES = 1024 * 1024;

/** Incremental reads keep a 200 MiB video out of one large ArrayBuffer. */
export async function hashUploadFile(file: File, signal?: AbortSignal): Promise<string> {
  signal?.throwIfAborted();
  const cached = digestCache.get(file);
  if (cached) return cached;
  const digest = sha256.create();
  try {
    for (let offset = 0; offset < file.size; offset += CHUNK_BYTES) {
      signal?.throwIfAborted();
      const chunk = new Uint8Array(await file.slice(offset, offset + CHUNK_BYTES).arrayBuffer());
      signal?.throwIfAborted();
      digest.update(chunk);
      // Yield between chunks so hashing does not monopolize the composer.
      await new Promise<void>((resolve) => setTimeout(resolve, 0));
    }
    signal?.throwIfAborted();
    const result = Array.from(digest.digest(), (byte) => byte.toString(16).padStart(2, '0')).join('');
    digestCache.set(file, result);
    return result;
  } finally {
    digest.destroy();
  }
}
